import React, { useState, useEffect, useRef } from 'react';
//componentes
import EncabezadoComponent from '../../Components/Encabezado/encabezado.component'
import CabezoteComponent from '../../Components/Cabezote/cabezote.component'
import Footer from '../../Components/Footer/Footer.components'
import arrow from '../../assets/icons/down.svg'
//axios
import axios from 'axios'
//constantes
import * as Constant from '../../global/const'
import auth from '../../Helpers/auth'
import { setSucursal } from '../../Redux/actions/PageActions';
import { useDispatch, useSelector } from 'react-redux';
import { useSucursal } from '../../Helpers/useSucursal';
import { ModalConfirmacionSucursal } from '../Checkout/Modales/modalConfirmacionSucursal.component';
import { useHistory } from 'react-router-dom';


var Slider = {
    position: 'absolute',
    backgroundColor: '#fff',
    border: "none",
    boxShadow: "0px 4px 5px #c1c1c1",
    borderTop: 0,
    width: '100%',
    zIndex: '4',
    paddingRight: '.2rem',
    height: '30vh',
    top: '2rem',
    overflow: 'hidden',
    opacity: '1',
    cursor: 'auto',
    borderRadius: ' 0 0 20px 20px',
    transition: 'all 0.5s',
}

var SliderMovil = {
    position: 'absolute',
    backgroundColor: '#fff',
    border: "2px solid #0075bb",
    width: '100%',
    zIndex: '50',
    paddingRight: '.2rem',
    height: '75vh',
    top: '110%',
    left: '50%',
    overflow: 'hidden',
    opacity: '1',
    cursor: 'auto',
    borderRadius: ' 0 0 20px 20px',
    transition: 'all 0.5s',
    tranform: 'translate(-50%,0)'
}

var CloseSlider = {
    height: 0,
    border: '0px',
    zIndex: '4',
    top: '2rem',
    position: 'absolute',
    backgroundColor: '#fff',
    width: '180px',
    overflow: 'hidden',
    opacity: '1',
}

const Sucursales = (props) => {


    const [close, setclose] = useState(false)
    const [filter, setfilter] = useState('')
    const [Allsucursales, setAllsucursales] = useState([])
    const [term, setterm] = useState('')
    const [sucursales, setsucursales] = useState([])
    const [ciudades, setciudades] = useState([]);
    const [open, setOpen] = useState(false);
    const [closeCabezote, setcloseCabezote] = useState(true);
    const userCurrent = JSON.parse(auth.getUsuario());
    //const Allsucursales=props.location.state.sucursales;
    const [showModal, setShowModal] = useState(false);
    const [valiteBranch, setValiteBranch] = useState(false);
    const [currentBranch, setCurrentBranch] = useState({});
    const [mostrarOpciones, setMostrarOpciones] = useState(false);
    const { getValidarCatalogo } = useSucursal();
    let history = useHistory();

    const dispatch = useDispatch();
    const CambiarSucursal = sucursal => dispatch(setSucursal(sucursal));
    const myRef = useRef();

    const getSucursales = () => {
        let user = JSON.parse(auth.getUsuario())
        axios.get(Constant.GETSUCRUSALES  + "?correo=" + user.email).then((response) => {
            setAllsucursales(response.data);
            setsucursales(response.data)
            getCuidades(response.data);
        }).catch((err) => {
            console.log("sucursales ", err);
        })
    }

    const handleClickOutside = (event) => {
        if (
            myRef.current &&
            !myRef.current.contains(event.target)
        ) {
            if (event.target.className.indexOf("activar") >= 0) {

            } else {
                setclose(false)
            }

        }
    };



    const getCuidades = (All) => {
        const arraySearch = Array.from(All)
        var cuidadesAux = []
        cuidadesAux.push('TODAS')
        arraySearch.forEach((sucursal) => {
            const index = cuidadesAux.findIndex((e) => e === sucursal.ciudad);
            if (index === -1) {
                cuidadesAux.push(sucursal.ciudad);
            }
        })
        setciudades(cuidadesAux)
    }

    const Filtrar = (ciudad) => {
        if (ciudad !== 'TODAS') {
            setfilter(ciudad)
            const arraySearch = Array.from(Allsucursales)
            const results = arraySearch.filter((e) => e.ciudad === ciudad);
            setsucursales(results)
        } else {
            setfilter(ciudad)
            setsucursales(Allsucursales)
        }
        setclose(false)
    }

    const Search = (term) => {
        if (term.trim() !== '') {
            const arraySearch = Array.from(Allsucursales)
            const SearchRepositories = arraySearch.filter(item => {
                return (
                    item.nombre.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
                    || item.codigo.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
                    || item.razonsocial.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
                )
            })

            var results = SearchRepositories;
            setsucursales(results)
        } else {
            setsucursales(Allsucursales)
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getSucursales();
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    useEffect(() => {
        if (valiteBranch) {
            getValidarCatalogo(currentBranch)
                .then(
                    response => {
                        CambiarSucursal(currentBranch);
                        setValiteBranch(false);
                        setShowModal(false);
                    }
                );
        }
    }, [valiteBranch])

    return (
        <div className="home" >
            <EncabezadoComponent path="/" desc1={'Inicio'} desc2="Negocios" inicio={true} />
            <CabezoteComponent
                open={open}
                setOpen={setOpen}
                tipo={false}
                categoriasGlobal={null}
                close={closeCabezote}
                setclose={setcloseCabezote}
                mostrarOpciones={mostrarOpciones}
                setMostrarOpciones={setMostrarOpciones}
            />
            <div className="Surcursales">
                <div className="HeaderSucursales">
                    <h2 className="titulo"><span>{userCurrent.nombreNegocio} -</span> Todas las sucursales</h2>
                    <div className="Boton" onClick={() => history.push("./Catalogo/Categoria/-1/Todos/1")}><span>Continuar comprando</span></div>
                </div>
                <div className="descripcion"><p>Estos son los puntos de venta que están activos.</p></div>
                <div className="content-search">
                    <input type="text" className="search buscar" value={term} onChange={(e) => { setterm(e.target.value); Search(e.target.value) }} placeholder="Buscar una sucursal" />

                    <div className="filter">
                        <div className="content activar" onClick={() => setclose(!close)}>
                            <span className="activar">{filter === '' ? 'Filtrar sucursales' : filter}</span>
                            <img className="activar" src={arrow} alt="" />
                        </div>
                        <div className=" close slider-sucursales " ref={myRef} style={!close ? CloseSlider : Slider}>
                            <div className="opciones overflow-auto scrollSlider">
                                {ciudades.map((ciudad, i) => (
                                    <div key={i} className="opcion" onClick={() => Filtrar(ciudad)}>
                                        <h6 className="no-seleccionable">{ciudad}</h6>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="filter2">
                        <div className="content activar">
                            <span className="activar">{filter === '' ? 'Filtros' : filter}</span>
                        </div>

                        <div className="close slider-sucursales overflow-auto scrollSlider" ref={myRef} style={!close ? CloseSlider : SliderMovil}>
                            <div className="opciones ">
                                {ciudades.map((ciudad, i) => (
                                    <div key={i} className="opcion" onClick={() => Filtrar(ciudad)}>
                                        <h6 className="no-seleccionable">{ciudad}</h6>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="flotante activar" onClick={() => setclose(!close)}>
                        {//<i className="fas fa-sliders-h activar"></i>
                        }
                        <span>Filtros</span>
                    </div>



                </div>

                <div className="body">
                    {sucursales.map((sucursal, i) => (
                        <div
                            className="card"
                            key={i}
                            onClick={
                                () => {
                                    setCurrentBranch(sucursal);
                                    setShowModal(true);
                                    // window.location.href = "/inicio"
                                }
                            }>
                            <div>
                                <h6 className="nombre">Nombre de la sucursal</h6>
                                <h6 className="nombre-2">{sucursal.razonsocial}</h6>
                            </div>
                            <div>
                                <h6 className="codigo">Código de la sucursal</h6>
                                <h6 className="codigo-2">{sucursal.codigo}</h6>
                            </div>
                            <div>
                                <h6 className="title-dias">Días de entrega</h6>
                                <h6 className="dias">{sucursal.diaEntrega}</h6>
                            </div>


                        </div>
                    ))}

                </div>
            </div>
            {
                showModal
                &&
                <ModalConfirmacionSucursal setShowModal={setShowModal} variable={valiteBranch} setVariable={setValiteBranch} />
            }
            <Footer />
        </div>
    )
}

export default Sucursales;